function Header() {
  return (
    <header className="flex items-center justify-between bg-blue-500 p-4 text-white">
      <div className="text-xl font-medium">Badkul Technology</div>
      <div>
        <button className="rounded-md bg-white px-3 py-1 text-sm font-medium text-blue-500">JSON Formatter</button>
      </div>
    </header>
  )
}

export default Header
